/**
 * Authentication State Slice
 */
import type { AuthState, AuthActions } from './types';
import type { User } from '../api/types/auth.types';

const initialState: AuthState = {
  token: null,
  user: null,
  isAuthorized: false,
};

export const createAuthSlice = (): AuthState & AuthActions => ({
  ...initialState,

  setToken: function (token: string | null) {
    this.token = token;
    this.isAuthorized = !!token;
  },

  setUser: function (user: User | null) {
    this.user = user;
  },

  setIsAuthorized: function (isAuthorized: boolean) {
    this.isAuthorized = isAuthorized;
  },

  reset: function () {
    this.token = null;
    this.user = null;
    this.isAuthorized = false;
  },
});

